
var TabsLayout = (function () {
    var TabsLayout = function () {
        this._object = $( '<div></div>' );
        this._tabs = $( '<ul class="tabs"></ul>' ).appendTo( this._object );
        this._contents = $( '<div class="tabsContents"></div>' ).appendTo( this._object );
        this._tabbs = {};
        this._currentTab = null;

    };
    var Tab = function ( name, title, content ) {
        this.name = name;
        this.header = $( '<li>' + title + '</li>' );
        this.content = $( '<div class="tabContent"></div>' ).append( content );
        this.onOpen = Signal.create( this );
        this.onClose = Signal.create( this );
    };
    Tab.prototype = {
        open : function () {
            this.header.addClass( 'selected' );
            this.content.addClass( 'tabContent-selected' );
            this.onOpen.fire();
        },
        close : function () {
            this.header.removeClass( 'selected' );
            this.content.removeClass( 'tabContent-selected' );
            this.onClose.fire();
        }
    };
    TabsLayout.prototype = {
        addTab : function ( name, title, content ) {
            var tabs = this;
            var tab = new Tab( name, title, content );
            this._tabs.append( tab.header );
            this._contents.append( tab.content );
            this._tabbs[ name ] = tab;
            tab.header.click( function () {
                tabs.openTab( name );
            } );
            return tab;
        },
        addLinkTab : function ( name, title, url ) {
            this._tabs.append( '<li><a href="' + url + '" target="_blank">' + title + '</a></li>' );
        },
        addButtonTab : function ( name, title, onClick ) {
            var btn = $( '<li>' + title + '</li>' );
            btn.click( onClick );
            this._tabs.append( btn );
        },
        addIframeTab : function ( name, title, url ) {
            var iframe = $( '<iframe class="tabsFrame"></iframe>' );
            var tab = this.addTab( name, title, iframe );
            tab.onOpen( function () {
                iframe.attr( 'src', url );
            } );
            return tab;
        },
        openTab : function ( name ) {
            var tab = this._currentTab;
            tab && tab.close();
            tab = this.getTab( name );
            tab && tab.open();
            this._currentTab = tab

        },
        getTab : function ( name ) {
            return this._tabbs[ name ];
        },
        getObject : function () {
            return this._object;
        }
    };
    return TabsLayout;
})();

